import { layerManager } from './layer_manager.js';
export { layerManager };
import AP_MAP_STYLES from './map_styles.json';
import {
    DRAWING_SHAPE_STYLES,
    SHAPE_STYLES,
    MOUSEOVER_SHAPE_STYLES,
    ACTIVATED_SHAPE_STYLES
} from './style_defaults.js';

// draw polygon and return it
export function drawPolygonFromPath(map, path, visible = true) {
    // console.log('plotting shape with strokeColor: #ff6347')
    const polygonOptions = {
        map: map,
        paths: google.maps.geometry.encoding.decodePath(path),
        clickable: true, // need this to respond to mouseover events
        visible: visible,
        ... SHAPE_STYLES,
    };
    // console.log('Polygon options:', polygonOptions);
    return new google.maps.Polygon(polygonOptions);
}

// draw circle and return it
export function drawCircleFromPath(map, centrePath, radius, visible = true) {
    const circleOptions = {
        map: map,
        center: google.maps.geometry.encoding.decodePath(centrePath)[0],
        radius: parseInt(radius, 10),
        clickable: true, // need this to respond to mouseover events
        visible: visible,
        ... SHAPE_STYLES,
    };
    return new google.maps.Circle(circleOptions);
}


// drop pin on polygon or circle - flights are blue, cranes are green, WIP are orange
export function addPinToShape(map, poly, applicationType) {
    const icon = (function () {
        switch (applicationType) {
            case 'flightApplication':
                return 'https://labs.google.com/ridefinder/images/mm_20_blue.png'
            case 'craneApplication':
                return 'https://labs.google.com/ridefinder/images/mm_20_green.png'
            case 'wipApplication':
                return 'https://labs.google.com/ridefinder/images/mm_20_orange.png'
        }
    })();


    addGetBoundsFunction();
    return new google.maps.Marker({
        position: poly.getBounds().getCenter(), // put it in the centre
        map: map,
        icon: icon,
        visible: false, // Start hidden, let the controller manage visibility
    })
}

////////////////////////////////////////////

export function setUpAazDrawingManager(map) {
    let dm = new google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['polygon']
        },
        polygonOptions: DRAWING_SHAPE_STYLES,
    });
    dm.setMap(map);
    return dm;
}

////////////////////////////////////////////

export function setUpFormMapDrawingManager(map, applicationType='flightApplication') {
    // All application types use the same drawing tools (circle and polygon)
    let dm = new google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ['circle', 'polygon']
        },
        circleOptions: DRAWING_SHAPE_STYLES,
        polygonOptions: DRAWING_SHAPE_STYLES,
    });
    dm.setMap(map);
    return dm;
}

////////////////////////////////////////////

export function hideDrawingManager(dm) {
    dm.setOptions({ drawingMode: null,  drawingControl: false, });
    layerManager.setDrawingMode(false);
}

////////////////////////////////////////////

export function showDrawingManager(dm) {
    dm.setOptions({ drawingMode: null,  drawingControl: true, });
    layerManager.setDrawingMode(true);
}

// export function addDrawingManagerListeners(dm) {
//     dm.setOptions({ drawingMode: null,  drawingControl: true, });
// }

//////////////////////////////////////////////////////////////////

export function mouseover(card, polygon, _pin) {
    // console.log('mouseover for card', card.dataset.id)
    card.classList.add("card-mouseover")
    highlightMapShape(card, polygon)
    // pin.setOptions({icon: 'https://labs.google.com/ridefinder/images/mm_20_blue.png',});
}

export function mouseout(card, polygon, _pin) {
    // console.log('mouseout for card', card.dataset.id)
    card.classList.remove("card-mouseover")
    highlightMapShape(card, polygon)
    // pin.setOptions({icon: 'https://labs.google.com/ridefinder/images/mm_20_red.png',});
}

export function highlightMapShape(card, shape) {
    if (card) {
        if (card.classList.contains('card-mouseover')) {    // mouse highlight so blue
            shape.setOptions({ ... MOUSEOVER_SHAPE_STYLES })
        } else {
            if (card.dataset.activated == 'true') {         // activated so red
              shape.setOptions({ ... ACTIVATED_SHAPE_STYLES });
            } else {                                        // no highlight at all - use default  color
                shape.setOptions({ ... SHAPE_STYLES});
            }
        }
    }
}

//////////////////////////////////////////////////////////////////

export function zoomToShape(map, shape) {
    if (shape == null) { return; }
    map.fitBounds(shape.getBounds());
}

//////////////////////////////////////////////////////////////////

export function addGetBoundsFunction() {
    google.maps.Polygon.prototype.getBounds = function() {
        var bounds = new google.maps.LatLngBounds();
        var paths = this.getPaths();
        var path;
        for (var i = 0; i < paths.getLength(); i++) {
            path = paths.getAt(i);
            for (var ii = 0; ii < path.getLength(); ii++) {
                bounds.extend(path.getAt(ii));
            }
        }
        return bounds;
    }
}

////////////////////////////////////////////

/**
 * Converts decimal degrees to degrees minutes seconds.
 *
 * @param dd the decimal degrees value.
 * @param isLng specifies whether the decimal degrees value is a longitude.
 * @return degrees minutes seconds string in the format 49°15'51.35"N
 */
function convertToDms(dd, isLng) {
    var dir = dd < 0
      ? isLng ? 'W' : 'S'
      : isLng ? 'E' : 'N';

    var absDd = Math.abs(dd);
    var deg = absDd | 0;
    var frac = absDd - deg;
    var min = (frac * 60) | 0;
    var sec = frac * 3600 - min * 60;
    // Round it to 2 decimal points.
    sec = Math.round(sec * 100) / 100;
    return deg + "°" + min.toString().padStart(2, '0') + "'" + sec.toString().padStart(2, '0') + '"' + dir;
  }

////////////////////////////////////////////

    // Good options for centering:
    // Warton: 53.745, -2.883333 - default
    // Gatwick: 51.148056, -0.190278
    // mapType options: google.maps.MapTypeId.SATELLITE, ROADMAP, HYBRID, TERRAIN
    // ROADMAP is default
    // SATELLITE is used for dashboard WIP and all the forms
export function defaultMapOptions(mapCentreLat = 53.745, mapCentreLon = -2.883333, scale = 12, mapType = google.maps.MapTypeId.ROADMAP) {
    return {
        center: new google.maps.LatLng(mapCentreLat, mapCentreLon),
        zoom: scale,
        mapTypeId: mapType,
        styles: AP_MAP_STYLES,
        gestureHandling: "greedy", // stops the map showing command + scroll to zoom
        streetViewControl: false,
    };
}

//////////////////////////////////////////////////////////////////

export function resolveMapTypeId(mapTypeStr) {
    switch ((mapTypeStr || 'roadmap').toLowerCase()) {
        case 'satellite': return google.maps.MapTypeId.SATELLITE;
        case 'hybrid':    return google.maps.MapTypeId.HYBRID;
        case 'terrain':   return google.maps.MapTypeId.TERRAIN;
        default:          return google.maps.MapTypeId.ROADMAP;
    }
}

//////////////////////////////////////////////////////////////////

export function stopLinkBeingFollowed(event) { // handy util to stop a link being followed, used for all maps
    event.preventDefault();
    event.stopPropagation();
}
